import createIcon from '../../createIcon';

/**
 * @component @name ScreenRotationAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA3LjU5MDg2TDkgMi41OTA4NkM5Ljc4IDEuODEwODYgMTEuMDUgMS44MTA4NiAxMS44MyAyLjU5MDg2TDIwLjI0IDExLjAwMDlIMTcuNDFMMTAuNCA0LjAwMDg2TDUuNDEgOS4wMDA4Nkg4VjExLjAwMDlIMlY1LjAwMDg2SDRWNy41OTA4NlpNMjAgMTkuMDAwOUgyMlYxMy4wMDA5SDE2VjE1LjAwMDlIMTguNTlMMTMuNiAyMC4wMDA5TDYuNTkgMTMuMDAwOUgzLjc2TDEyLjE3IDIxLjQxMDlDMTIuOTUgMjIuMTkwOSAxNC4yMiAyMi4xOTA5IDE1IDIxLjQxMDlMMjAgMTYuNDEwOVYxOS4wMDA5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ScreenRotationAlt = createIcon('ScreenRotationAlt', [
  [
    'path',
    {
      d: 'M4 7.59086L9 2.59086C9.78 1.81086 11.05 1.81086 11.83 2.59086L20.24 11.0009H17.41L10.4 4.00086L5.41 9.00086H8V11.0009H2V5.00086H4V7.59086ZM20 19.0009H22V13.0009H16V15.0009H18.59L13.6 20.0009L6.59 13.0009H3.76L12.17 21.4109C12.95 22.1909 14.22 22.1909 15 21.4109L20 16.4109V19.0009Z',
      key: 'h33yk3',
    },
  ],
]);

export default ScreenRotationAlt;
